import { Component, effect, input, OnDestroy, output, signal } from '@angular/core';
import { TranslatePipe } from '@cmi/addin-core';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'cmi-search-bar',
  imports: [TranslatePipe],
  templateUrl: './search-bar.html'
})
export class SearchBar implements OnDestroy {
  public searchTerm = input<string>();
  public searchTermChanged = output<string>();

  private readonly _searchSubject = new Subject<string>();
  protected readonly currentSearchTerm = signal<string>('');

  public constructor() {
    // Set up debounced search
    this._searchSubject.pipe(debounceTime(300), distinctUntilChanged()).subscribe((term) => {
      this.searchTermChanged.emit(term);
    });

    // Sync input with internal signal
    effect(() => {
      const term = this.searchTerm();
      // Update internal signal when input changes, including empty strings
      if (term !== undefined) {
        this.currentSearchTerm.set(term);
      }
    });
  }

  public onSearchInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;
    this.currentSearchTerm.set(value);
    this._searchSubject.next(value);
  }

  public ngOnDestroy(): void {
    this._searchSubject.complete();
  }
}
